import React, { useState } from 'react';
import useTheme from '../../hooks/useTheme';
import PropTypes from 'prop-types';
import { CheckIcon, CheckIndeterminate } from '../../assets/icons/index';

const CustomCheckbox = ({
	checked = false,
	onChecked,
	dataTestId = 'customCheckbox',
	indeterminate = false,
	sx = {},
	disabled = false,
}) => {
	const { color } = useTheme();
	const [isHovered, setIsHovered] = useState(false);
	
	const handleMouseEnter = () => setIsHovered(true);
	const handleMouseLeave = () => setIsHovered(false);

	const handleCheckboxChange = (event) => {
		if (!disabled) {
		  event.stopPropagation(); // Prevent event from bubbling up
		  console.log('Checkbox clicked');
		  onChecked(!checked); // Only notify the parent of the new state
		}
	  };

	return (
		<div
			data-testid={dataTestId}
			style={{
				width: '14px',
				height: '14px',
				// border: `1px solid ${
				// 	checked || indeterminate
				// 		? color.button.primary
				// 		: color.button.secondary_outline
				// }`,
				border: `1px solid ${
					disabled
					  ?  '#b2b2b2' 
					  : checked || indeterminate
					  ? color.button.primary
					  : color.button.secondary_outline
				}`,
				padding: '1px',
				borderRadius: '2px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				cursor: disabled ? 'url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'24\' height=\'24\' viewBox=\'0 0 24 24\'><text x=\'0\' y=\'20\' font-size=\'20\' fill=\'red\'>🚫</text></svg>"), not-allowed' : 'pointer',
				backgroundColor: disabled
					? '#dedede'
					: isHovered
					? color.button.primary_outline_pressed
					: checked || indeterminate
					? color.button.primary_outline_pressed
					: 'transparent',
				...sx,
			}}
			onClick={handleCheckboxChange}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			{checked && <CheckIcon />}
			{indeterminate && <CheckIndeterminate />}
		</div>
	);
};

CustomCheckbox.propTypes = {
	checked: PropTypes.bool.isRequired,
	onChecked: PropTypes.func,
	dataTestId: PropTypes.string,
	sx: PropTypes.object,
	indeterminate: PropTypes.bool,
	disabled: PropTypes.bool,
};

CustomCheckbox.defaultProps = {
	onChecked: () => {},
};


export default CustomCheckbox;
